import {
  AvailableTime,
  SatisfactionInfo,
} from "../services/spaceReservationServices";

export type RentStatusValue =
  | "REQUESTED"
  | "CANCELED"
  | "RENTED"
  | "COMPLETED"
  | "LOST_DAMAGED"
  | "OVERDUE"
  | "DONE";

export enum RentStatus {
  REQUESTED = "신청중",
  CANCELED = "신청 취소",
  RENTED = "대여중",
  COMPLETED = "반납 완료",
  LOST_DAMAGED = "분실 손상",
  OVERDUE = "연체",
  DONE = "취소/완료",
}

export const StepRentStatus = {
  REQUESTED: 1,
  CANCELED: 3,
  RENTED: 2,
  COMPLETED: 3,
  LOST_DAMAGED: 2,
  OVERDUE: 2,
  DONE: 3,
};

// 날짜 데이터 기본 포맷 "2023/08/01 16:37:50";
export type RentDetail = {
  rentDetailId: string;
  reservationSpaceId: string;
  status: RentStatusValue; //"2023-07-06";
  createdAt: AvailableTime;
  satisfactionInfo?: SatisfactionInfo;
  categoryNameS?: string;
  categoryNameM?: string;

  productName?: string;

  contactInfo?: string;
  contactNumber?: string;

  buildingName?: string;

  receiveBuildingName?: string;
  receiveFloorName?: string;
  receiveSpaceName?: string;

  companyName?: string;

  userName?: string;

  canceledAt?: AvailableTime;
  rentedAt?: AvailableTime;
  receiveAt?: AvailableTime;

  isDamaged?: boolean;
  isManualReceived?: boolean;
};

export const SERVICE_REQUEST_TIMEOUT = 15 * 60;
export const RENT_REQUEST_TIMEOUT = 15 * 60;
